import { render, staticRenderFns } from "./inputer-number.vue?vue&type=template&id=2be8cfa1"
import script from "./inputer-number.vue?vue&type=script&lang=js"
export * from "./inputer-number.vue?vue&type=script&lang=js"
import style0 from "./inputer-number.vue?vue&type=style&index=0&id=2be8cfa1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports